import { useState } from "react";

export const useAPIEndpointOperationFormState = () => {
  const [formData, setFormData] = useState({
    /* ================= SELECT FIELDS ================= */
    apiRegistryId: null,
    apiCategoryId: null,
    apiEndpointId: null,
    protocolId: null,
    httpMethodId: null,
    graphqlOperationTypeId: null,
    requestSchemaId: null,
    responseSchemaId: null,
    notificationSchemaId: null,

    /* ================= TEXT / INPUT ================= */
    operationCode: "",
    soapAction: "",
    pathTemplate: "",
    headersConfig: "",
    payloadExample: "",
    version: "",

    /* ================= FLAGS ================= */
    isActive: true,

    /* ================= STATUS FLAGS ================= */
    apiRegistryIdStatus: "unchecked",
    apiCategoryIdStatus: "unchecked",
    apiEndpointIdStatus: "unchecked",
    protocolIdStatus: "unchecked",
    httpMethodIdStatus: "unchecked",
    graphqlOperationTypeIdStatus: "unchecked",

    operationCodeStatus: "unchecked",
    soapActionStatus: "unchecked",
    pathTemplateStatus: "unchecked",
    requestSchemaIdStatus: "unchecked",
    responseSchemaIdStatus: "unchecked",
    notificationSchemaIdStatus: "unchecked",

    headersConfigStatus: "unchecked",
    payloadExampleStatus: "unchecked",
    versionStatus: "unchecked",
  });

  const handleChange = (event, selectEvent) => {
    const state = { ...formData };

    /* ================= SELECT HANDLER ================= */
    if (!event?.target && selectEvent) {
      state[selectEvent.name] = event;
      state[`${selectEvent.name}Status`] = event?.value
        ? "success"
        : "unchecked";
      setFormData(state);
      return;
    }

    const { name, value, type, checked } = event.target;

    /* ================= JSON FIELDS ================= */
    if (name === "headersConfig" || name === "payloadExample") {
      try {
        JSON.parse(value);
        state[`${name}Status`] = value ? "success" : "unchecked";
      } catch {
        state[`${name}Status`] = value ? "error" : "unchecked";
      }
    } else if (
      /* ================= NORMAL INPUTS ================= */
      name.endsWith("Code") ||
      name === "soapAction" ||
      name === "pathTemplate" ||
      name === "version"
    ) {
      state[`${name}Status`] = value ? "success" : "unchecked";
    }

    state[name] = type === "checkbox" ? checked : value;
    setFormData(state);
  };

  // const checkAllFields = () =>
  //   formData.apiRegistryIdStatus === "success" &&
  //   formData.apiCategoryIdStatus === "success" &&
  //   formData.apiEndpointIdStatus === "success" &&
  //   formData.protocolIdStatus === "success" &&
  //   formData.operationCodeStatus === "success" &&
  //   formData.versionStatus === "success";
  const checkAllFields = () => {
    return Object.entries(formData)
      .filter(([key]) => key.endsWith("Status"))
      .every(([, value]) => value === "success");
  };

  return {
    formData,
    setFormData,
    handleChange,
    checkAllFields,
  };
};
